module.exports = __webpack_public_path__ + "img/FAQ.c2020577.svg";